import { fetchAllPostPromisedData, updateRequest, dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";

export const getDropdowns = async () => {
    const dropdown = await Promise.all([
        dropdownMapping(
            endpoint.academic_career.getAllActive,
            "academicCareerDispValue",
            "id"
        ),
        dropdownMapping(
            endpoint?.term.getAllActive,
            "termDispValue",
            "id"
        ),
    ]);
    return {
        academicCareers: dropdown[0],
        terms: dropdown[1]
    };
}

export const EMPTY_FILTER_FORM = {
    vendorName: "",
    value: "",
    acadmicCareerIds: [],
    termIds: [],
    effectiveFrom: "",
    effectiveTo: "",
    appliedFilterCount: 0,
}

export const getFilterFormFields = (dropdownData, filterForm) => {
    const { terms, academicCareers } = dropdownData;

    return [
        {
            label: "Vendor Name (Ex BFL,PRP ...)",
            type: "text",
            formKey: "vendorName",
            placeholder: "Enter Vedndor",
        },
        {
            label: "Scheme Code (EX:10/2)",
            type: "text",
            formKey: "value",
            placeholder: "Enter scheme",
        },
        {
            label: 'Academic Career',
            type: 'select',
            items: academicCareers,
            formKey: 'acadmicCareerIds',
            onChange: () => { },
            loading: false,
            isMulti: true,
            placeholder: "Select Academic Career",
            disbabled: false,
            isShowCount: true
        },
        {
            label: 'Term',
            type: 'select',
            items: terms,
            formKey: 'termIds',
            onChange: () => { },
            loading: false,
            isMulti: true,
            placeholder: "Select term",
            disbabled: false,
            isShowCount: true
        },
        {
            label: "Effective Date from",
            type: "date",
            formKey: "effectiveFrom",
            placeholder: "Select Date",
            maxDate: filterForm?.effectiveTo
        },
        {
            label: "Effective Date to",
            type: "date",
            formKey: "effectiveTo",
            placeholder: "Select Date",
            minDate: filterForm?.effectiveFrom
        },
    ]
}

export const searchLoanMaster = async (reqObj, page = 0, size = 50) => {
    return await fetchAllPostPromisedData(`${endpoint.loanScheme}/search?page=0&size=50`, reqObj, 'post');
}